var loadData = true;

Vue.filter('stripTags', function(value) {
    if (!value) return '';
    return value.replace(/&lt;.+?&gt;/g, '');
});

Vue.filter('stripTagsShort', function(value) {
    if (!value) return '';
    return value.replace(/&lt;.+?&gt;/g, '').substr(0, 80) + '...';
});

Vue.filter('formatDate', function(value, format, lang) {
    if (value) {
      moment.locale('fr');
      return moment.unix(String(value)).format(format)
    }
  });

/////////////////////////////////////////////
//////// Track Google Analytics Events /////
///////////////////////////////////////////
document.querySelectorAll('.gtag').forEach(function(gtagElement) {
    gtagElement.addEventListener("click", function(e) {
        e.preventDefault();
        //console.log(this); 

        var action = this.dataset.action;
        var category = this.dataset.category;
        var label = this.dataset.label;
        var value = this.dataset.value;
        var href = this.getAttribute('href');

        gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'value': value,
            'event_callback': function() {
                if (!!href) window.location = href;
            }
        });

        // ga('send', 'event', {
        //     eventCategory: category,
        //     eventAction: action,
        //     eventLabel: label,
        //     eventValue: value,
        //     hitCallback: function() {
        //         window.location = href;
        //     }
        // });
    })
});


// (function() {
//     var threshold = .1
//     var options = {
//         root: null,
//         threshold: threshold,
//         rootMargin: '0px'
//     }
//     var handleIntersect = function (entries, observer) {
//         entries.forEach(function (entry) {
//             if (entry.intersectionRatio < threshold) {
//                 return
//             }
//             entry.target.classList.add('reveal-visible')
//             observer.unobserve(entry.target)
//         })
//     }
//     var observer = new IntersectionObserver(handleIntersect, options)
//     observed = document.querySelectorAll('[class*="reveal-"]')
//     observed.forEach(function(r) { observer.observe(r) })
// })